/*<--
    <div jv-Viewfields
        get-Fields-From="../../action/application/addCandidate"
        view-Fields="candidateFields.viewFields"
        show-Hide-Fields="true"
        edit-Mode="candidateFields.editMode"
        validation-On="candidateFields.startValidation"
        settings="candidateFields.settings"
    ></div>
-->*/

angular.module('jv.directives').directive('jvViewfields',[function(){
    return {
        replace: false,
//      restrict:'A',
        templateUrl:'/jhire/modules/candidates/viewFields.html',
        /*@_isolated scope*/
        scope:{
            viewFields:'=',
            showHideFields:'=',
            validationOn:'=',
            getFieldsFrom:'@',
            getFieldsUrl:'=',
            editMode:'=',
            settings:'=',
            getValidatedData:'=',
            isIE:'&',
            response:'=',
            i18n:'=',
            coverLetterUploader:'=',
            attachmentUploader:'='
        },

        /*@_bahavior native isolated scope*/
        controller: function($scope, $element, $attrs, viewFieldsFAC, $http, $q, candidates, jvFormFieldDropDownValuesFAC, $routeParams){
            $scope.isDefined = angular.isDefined;
            $scope.employeeSelect=candidates.employeeSelect;
            $scope.companyEId = $routeParams.companyId || '';
            $scope.candFormFields = jvFormFieldDropDownValuesFAC;
            /*get the fields and parse*/
            var getUrl= $attrs.getFieldsFrom || $scope.getFieldsUrl;
            getUrl += (getUrl.indexOf('?') >= 0) ? '&' : '?';
            $http.get(getUrl+'ts='+ new Date().getTime()).then(function(responseData){
                var response = responseData.data;
                $scope.response= response;
                $scope.viewFields=viewFieldsFAC.parseFields(response.viewFields, $scope.editMode, $scope.settings);
                $scope.fieldIsInvalid= function(field){
                    return $scope.validationOn && viewFieldsFAC.fieldIsInvalid(field);
                };
                $scope.fieldIsNAN = function(field){
                    if(field.fieldType === 'Number' || field.fieldType === 'Amount'){
                        return $scope.validationOn && $scope.$root.isNumberValid(field.value);
                    }
                    return false;
                };
                $scope.changeCountry=function(fields,value){
                    angular.forEach(fields, function(field){
                        if(field.fieldId === -36){
                            field.fieldType = value === 'United States'?'DropDown':'Name';
                        }
                    });
                };
                $scope.getType = function(field){
                    if(field.objectType === 'Divider'){
                        field.fieldType = 'Divider';
                    }
                    return field.fieldType;
                };
                $scope.getClass = function(field){
                    var className = field.objectType;
                    if(className === 'Divider'){
                        className = '';
                    }
                    return className;
                };
            });
        }
    };
}]);


// @TODO Move the View Fields factory out into its own file
angular.module('jv.services').factory('viewFieldsFAC', function($http, $log){

    this.isEmailValid= function(email){
        if(!window.EMAIL_REGEX){
            throw new Error('EMAIL_REGEX is not defined');
        }
        var emailPattern = new RegExp( window.EMAIL_REGEX );
        return emailPattern.test( email );
    };

    this.isNumberValid = function (value) {
        if(value) {
            return isNaN(value.toString().replace(/[,.]/g, ''));
        } else {
            return false;
        }
    };

    this.parseFields= function(fields, editMode, settings){
        angular.forEach(fields, function(field){
            if(editMode){
                /*hack for add candidate page*/
                field.placeholder=field.name;
                if(settings && settings.mergeFirstLastName){
                    if(field.fieldId === -1){
                        field.name= 'Name';
                    }else if(field.fieldId === -2){
                        field.noBorder=true;
                        field.name='';
                    }
                }
                if(field.fieldType && field.fieldType.toUpperCase()==='CHECKBOX' && field.value && field.values){
                    var selectedValues= field.value.split('\n');
                    angular.forEach(field.values, function(checkboxOption){
                        if($.inArray(checkboxOption.key, selectedValues)>=0){
                            checkboxOption.checked=true;
                        }
                    });
                }

                if(field.fieldId === -7){
                    $http.get(window.jvUrls.source+'/action/sys/countries').then(function(responseData){
                        var response = responseData.data;
                        var countryList=[];
                        if(angular.isDefined(response.resultList)){
                            angular.forEach(response.resultList, function(country){
                                countryList.push({key: country.country, value: country.country + '-'+ country.threeLetterAcronym});
                            });
                            field.values=countryList;
                            field.onChangeOption=true;
                        }
                    }, function(error){
                        $log.error(error);
                    });
                }
                //For veteran status, I have to modify the json to adjust it to my requirement
                if(field.fieldId === -63) {
                    var data = {};
                    angular.forEach(field.data, function (item) {
                        if(!item) {
                            return;
                        }
                        data[item.key] = {values: item.value, model: {}};
                    });
                    field.data = data;
                }
            }else{
                if(field.fieldType && field.fieldType.toUpperCase()==='DATE' && field.value){
                    field.value=new Date(field.value);
                }
                field.readOnly=true;
            }
        });
        return fields;
    };

    this.fieldIsInvalid= function(field){
        var invalid=false;
        if(field.required && !field.readOnly){
            if(field.fieldType==='CheckBox'){
                var checkBoxIsEmpty=true;
                angular.forEach(field.values, function(checkboxOption){
                    if(checkboxOption.checked){
                        checkBoxIsEmpty=false;
                    }
                });
                invalid= checkBoxIsEmpty? true: false;
            }else if(field.fieldType === 'Currency'){
                invalid = !(field.value && field.value.currencyCode && !!field.value.value);
            }
            /* CoverLetter(-15) and Attachement(-61) fields will have a value as object (uploaded file)
            ** Checking for empty object when field is marked as required.
            */
            else if(field.fieldId === -15 || field.fieldId === -61){
                 invalid = $.isEmptyObject(field.value);
            }
            else{
                invalid= !field.hide && !field.value;
            }
        }
        //email-id check
        if(field.fieldId === -3 && field.value){
            field.emailError= (invalid && !field.value)? false : !this.isEmailValid(field.value);
        }else{
            field.emailError=false;
        }
        if(field.fieldType === 'Number' || field.fieldType === 'Amount'){
            field.numberError = this.isNumberValid(field.value);
        }
        field.error=invalid;
        return field.error;
    };

    this.validateFields= function(viewFields){
        var data ={};
        for(var eachfield in viewFields){
            var field=viewFields[eachfield];
            if(!this.fieldIsInvalid(field) && !field.emailError && !field.numberError){
                if(field.fieldType){
                    if((field.fieldType==='Employee' || field.fieldType==='EmployeeNoDefault') && field.value){
                        data[field.EId]= data[field.EId] || [];
                        data[field.EId].push(field.value.EId);
                    }else if(field.fieldType==='CheckBox'){
                        angular.forEach(field.values, function(option){ // eslint-disable-line
                            if(option.checked){
                                data[field.EId]=data[field.EId] || [];
                                data[field.EId].push(option.key);
                            }
                        });
                    }else if(field.fieldType === 'Currency' && field.value !=='' && angular.isObject(field.value)){
                        data[field.EId] = JSON.stringify({
                            currencyCode: field.value.currencyCode,
                            value: angular.copy(field.value.value)
                        });
                    }else{
                        if(field.value){
                            data[field.EId]=field.value;
                        }
                    }
                    if(field.fieldId === -63) {
                        var radioModel = data[field.EId];
                        var temporaryCheckboxModel = '';
                        if(angular.isDefined(field.data[radioModel])) {
                            var checkboxModel = field.data[radioModel].model;
                            angular.forEach(checkboxModel, function (value, key) { // eslint-disable-line
                                if(value) {
                                    temporaryCheckboxModel = temporaryCheckboxModel + '|' + key;
                                }
                            });
                            data[field.EId] = data[field.EId] + temporaryCheckboxModel;
                        }
                    }
                }
            }else{
                return '';
            }
        }
        return data;
    };

    return this;
});
